import { render } from "./QuizStep2.vue?vue&type=template&id=c9b27b5e"
import script from "./QuizStep2.vue?vue&type=script&lang=js"
export * from "./QuizStep2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__